import { Fragment, useState, useEffect } from 'react';
import { List, ListItemText, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { ListItem } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CheckboxFilter from './CheckboxFilter';
import TextFilter from './TextFilter';
import './SampleFilter.css';
import DropdownFilter from './DropdownFilter';
import FiscalQuarterFilter from './FiscalQuarterFilter';
import LocationFilter from '../LocationFilter/LocationFilter';
import InputLabel from '@mui/material/InputLabel';
import StateCountyFilter from './StateCountyFilter';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MinMaxFilter from './MinMaxFilter';
import ToFromDateFilter from './ToFromDateFilter';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import FiscalYearFilter from './FiscalYearFilter';
import FieldNames from '../../../defaults/FieldNames.json';

import {
  setEstPersonnelCost,setEstGrantsFixedCost,setEstTotalCost,setEstAssetCost,setEstOtherCost,setEstContractualCost,setFilterProjectValue,
  setIsRTRL,setFundingSources, setState, setCounty, setCongressionalDistrict, setPostFireType, setFuelsType, 
  setIsContract, setIsAgreement,
  setMinDurability,setMaxDurability,setMinCalculatedArea,setMaxCalculatedArea,setCalculatedAreaType,setMinInitiationDate,setMaxInitiationDate,setMinEstPersonnelCost,setMaxEstPersonnelCost,setMinEstGrantsFixedCost,
  setMaxEstGrantsFixedCost,setMinEstAssetCost,setMaxEstAssetCost,setMinEstContractualCost,setMaxEstContractualCost,setMinEstOtherCost,setMaxEstOtherCost,setMinEstTotalCost,setMaxEstTotalCost, 
  setMinFiscalYear, setMaxFiscalYear,setFilterGeometry, setPriorities, setMinCompletionDate, setMaxCompletionDate, setMinCompletionFiscalYear, setMaxCompletionFiscalYear, setMinObligationFiscalYear, setMaxObligationFiscalYear,
  setInitiationFiscalQuarters, setCompletionFiscalQuarters, setIsDepartmentApproved, setIsAgencyApproved, setIsRegionApproved, setIsLocalApproved, setIsAllApproved, setIsNoneApproved, setStatus, setNames,
  setFundingAgency, setFundingDepartment, setFundingRegion, setFundingUnit, setFundingSubUnit, setFundingUnitType, setFundingUnitTypeIgnoreNational, setFundingTribe, setWbsIds, 
  setIsCarryover, setIgnoreContributedOnly, setProjectDiscoveryDates, setProjectIDs, setProjectFireCodes, setPostFireCategories, setFuelsCategories, setIsInteragency} from '../../../redux/slices/filterSlice';
import AutoCompleteFilter from './AutoCompleteFilter';
import AutoCompleteLinkedFilter from './AutoCompleteLinkedFilter';
import ColorConstants from '../../../defaults/ColorConstants';
import AutoCompleteProjectLinkedFilter from './AutoCompleteProjectLinkedFilters';
import CalculatedAreaFilter from './CalculatedAreaFilter';

const useStyles = makeStyles(() => ({
  filterItemHeader: {
    display:'flex', 
    justifyContent:'center', 
    padding: '10px 0px 10px 10px', 
    backgroundColor: ColorConstants.WhiteAlien, 
    color: ColorConstants.BlueAlien, 
    borderBottom: '1px solid', 
    borderBottomColor: ColorConstants.BlueAlien,
    '&:hover': {
      backgroundColor: ColorConstants.BlueAlien,
      color: ColorConstants.WhiteAlien
    }
  },
  filterItemHeaderSelected: {
    display:'flex', 
    justifyContent:'center', 
    padding: '10px 0px 10px 10px', 
    backgroundColor: ColorConstants.BlueAlien, 
    color: ColorConstants.WhiteAlien, 
    borderBottom: '1px solid', 
    borderBottomColor: ColorConstants.BlueAlien,
    fontWeight: '500',
    '&:hover': {
      backgroundColor: ColorConstants.BlueAlien,
      color: ColorConstants.WhiteAlien
    }
  }
}));

const theme = createTheme({
  overrides: {
  },
});

export default function TitleFilter({ filter, typeSelection, isRTRLSelection, categorySelection, fundingSourceSelection, congressDistValues,
  prioritiesSelection, initiationFiscalQuarterSelection, completionFiscalQuarterSelection, 
  statusSelection, isCreatingActualActivity, isCreatingActualTreatment, 
  isCreatingPlannedTreatment, isCreatingPlannedActivity, wbsIDValues, isCarryoverSelection,
  rootServiceUrl, config, datasetSelection}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const dispatch = useDispatch();

  const filterProjectValue = useSelector((state) => state.filter.filterProjectValue);
  const projectDiscoveryDateValue = useSelector((state) => state.filter.projectDiscoveryDates);
  const projectIDValue = useSelector((state) => state.filter.projectIDs);
  const projectFireCodeValue = useSelector((state) => state.filter.projectFireCodes);
  const postFireCategoryValue = useSelector((state) => state.filter.postFireCategories);
  const fuelsCategoryValue = useSelector((state) => state.filter.fuelsCategories)
  const prioritiesValue = useSelector((state) => { return state.filter.priorities });
  const postFireTypeValue = useSelector((state) => state.filter.postFireTypes);
  const fuelsTypeValue = useSelector((state) => state.filter.fuelsTypes)
  const isRTRLValue = useSelector((state) => state.filter.isRTRL);
  const isContractValue = useSelector((state) => state.filter.isContract);
  const isAgreementValue = useSelector((state) => state.filter.isAgreement);
  const wbsIDSelectedValues = useSelector((state) => state.filter.wbsIds);
  const fundingSourceValue = useSelector((state) => state.filter.fundingSources);
  const congressDistValue = useSelector((state) => state.filter.congressionalDistrict);
  const fundingDepartment = useSelector((state) => state.filter.fundingDepartment);
  const fundingAgency = useSelector((state) => state.filter.fundingAgency);
  const fundingRegion = useSelector((state) => state.filter.fundingRegion);
  const fundingUnit = useSelector((state) => state.filter.fundingUnit);
  const fundingSubUnit = useSelector((state) => state.filter.fundingSubUnit);
  const fundingTribe = useSelector((state) => state.filter.fundingTribe);
  const fundingUnitType = useSelector((state) => state.filter.fundingUnitType);
  const fundingUnitTypeIgnoreNational = useSelector((state) => state.filter.fundingUnitTypeIgnoreNational);
  const ignoreContributedOnly = useSelector((state) => state.filter.ignoreContributedOnly);
  const stateValue = useSelector((state) => state.filter.states);
  const countyValue = useSelector((state) => state.filter.counties);
  const minDurabilityValue = useSelector((state) => state.filter.minDurability);
  const maxDurabilityValue = useSelector((state) => state.filter.maxDurability);
  const minCalculatedAreaValue = useSelector((state) => state.filter.minCalculatedArea);
  const maxCalculatedAreaValue = useSelector((state) => state.filter.maxCalculatedArea);
  const calculatedAreaType = useSelector((state) => state.filter.calculatedAreaType);
  const minInitiationDateValue = useSelector((state) => state.filter.minInitiationDate);
  const maxInitiationDateValue = useSelector((state) => state.filter.maxInitiationDate);
  const minCompletionDateValue = useSelector((state) => state.filter.minCompletionDate);
  const maxCompletionDateValue = useSelector((state) => state.filter.maxCompletionDate);
  const minEstPersonnelCost = useSelector((state) => state.filter.minEstPersonnelCost);
  const maxEstPersonnelCost = useSelector((state) => state.filter.maxEstPersonnelCost);
  const minEstGrantsFixedCost = useSelector((state) => state.filter.minEstGrantsFixedCost);
  const maxEstGrantsFixedCost = useSelector((state) => state.filter.maxEstGrantsFixedCost);
  const minEstAssetCost = useSelector((state) => state.filter.minEstAssetCost);
  const maxEstAssetCost = useSelector((state) => state.filter.maxEstAssetCost);
  const minEstContractualCost = useSelector((state) => state.filter.minEstContractualCost);
  const maxEstContractualCost = useSelector((state) => state.filter.maxEstContractualCost);
  const minEstOtherCost = useSelector((state) => state.filter.minEstOtherCost);
  const maxEstOtherCost = useSelector((state) => state.filter.maxEstOtherCost);
  const minEstTotalCost = useSelector((state) => state.filter.minEstTotalCost);
  const maxEstTotalCost = useSelector((state) => state.filter.maxEstTotalCost);
  const minFiscalYear = useSelector((state) => state.filter.minFiscalYear);
  const maxFiscalYear = useSelector((state) => state.filter.maxFiscalYear);
  const initiationFiscalQuartersValue = useSelector((state) => state.filter.initiationFiscalQuarters);
  const completionFiscalQuartersValue = useSelector((state) => state.filter.completionFiscalQuarters);
  const minCompletionFiscalYear = useSelector((state) => state.filter.minCompletionFiscalYear);
  const maxCompletionFiscalYear = useSelector((state) => state.filter.maxCompletionFiscalYear);
  const minObligationFiscalYear = useSelector((state) => state.filter.minObligationFiscalYear);
  const maxObligationFiscalYear = useSelector((state) => state.filter.maxObligationFiscalYear);
  const filterGeometryValue = useSelector((state) => state.filter.filterGeometry);
  const isDepartmentApproved = useSelector((state) => state.filter.isDepartmentApproved);
  const isAgencyApproved = useSelector((state) => state.filter.isAgencyApproved);
  const isRegionApproved = useSelector((state) => state.filter.isRegionApproved);
  const isLocalApproved = useSelector((state) => state.filter.isLocalApproved);
  const isAllApproved = useSelector((state) => state.filter.isAllApproved);
  const isNoneApproved = useSelector((state) => state.filter.isNoneApproved);
  const isInteragency = useSelector((state) => state.filter.isInteragency);
  const statusValue = useSelector((state) => state.filter.status);
  const isCarryoverValue = useSelector((state) => state.filter.isCarryover);
  const [fundingDepartmentSelection, setFundingDepartmentSelection] = useState(fundingDepartment ? fundingDepartment : [{Department: ""}]);
  const [fundingAgencySelection, setFundingAgencySelection] = useState(fundingAgency ? fundingAgency : [{Agency: ""}]);
  const [fundingRegionSelection, setFundingRegionSelection] = useState(fundingRegion ? fundingRegion : [{Region: ""}]);
  const [fundingUnitSelection, setFundingUnitSelection] = useState(fundingUnit ? fundingUnit : [{Unit: ""}]);
  const [fundingSubUnitSelection, setFundingSubUnitSelection] = useState(fundingSubUnit ? fundingSubUnit : [{SubUnit: ""}]);
  const [fundingTribeSelection, setFundingTribeSelection] = useState(fundingTribe ? fundingTribe : [{TribeFullName: ""}]);
  const [fundingUnitTypeSelection, setFundingUnitTypeSelection] = useState(fundingUnitType ? fundingUnitType : [{UnitType: ""}]);
  const [fundingUnitTypeIgnoreNationalVal, setFundingUnitTypeIgnoreNationalVal] = useState(fundingUnitTypeIgnoreNational ? fundingUnitTypeIgnoreNational : false);
  const [ignoreContributedOnlyVal, setIgnoreContributedOnlyVal] = useState(ignoreContributedOnly ? ignoreContributedOnly : false);
  const nameValues = useSelector((state) => state.filter.names);
 
  const actionCategoryAssociations = useSelector((state) => state.globalContext.actionCategoryAssociations);

  const [projectNameSelection, setProjectNameSelection] = useState(filterProjectValue ? filterProjectValue : []);
  const [projectDiscoveryDateSelection, setProjectDiscoveryDateSelection] = useState(projectDiscoveryDateValue ? projectDiscoveryDateValue : []);
  const [projectIDSelection, setProjectIDSelection] = useState(projectIDValue ? projectIDValue : []);
  const [projectFireCodeSelection, setProjectFireCodeSelection] = useState(projectFireCodeValue ? projectFireCodeValue : []);

  // State Caching
  const [cachedNameValues,setCachedNameValues] = useState([]);
  const [cachedProjects,setCachedProjects] = useState([]);

  useEffect(() => {
    return () => {
      setCachedNameValues([]);
    }
  }, [])

  useEffect(() => {
    return () => {
      setCachedProjects([]);
    }
  }, [])

  useEffect(() => {
    setFundingDepartmentSelection(fundingDepartment ? fundingDepartment : [{Department: ""}]);
    setFundingAgencySelection(fundingAgency ? fundingAgency : [{Agency: ""}]);
    setFundingRegionSelection(fundingRegion ? fundingRegion : [{Region: ""}]);
    setFundingUnitSelection(fundingUnit ? fundingUnit : [{Unit: ""}]);
    setFundingSubUnitSelection(fundingSubUnit ? fundingSubUnit : [{SubUnit: ""}]);
    setFundingTribeSelection(fundingTribe ? fundingTribe : [{TribeFullName: ""}]);
    setFundingUnitTypeSelection(fundingUnitType ? fundingUnitType : [{UnitType: ""}]);
    setFundingUnitTypeIgnoreNationalVal(fundingUnitTypeIgnoreNational ? fundingUnitTypeIgnoreNational : false);
    setIgnoreContributedOnlyVal(ignoreContributedOnly ? ignoreContributedOnly : false);
  }, [fundingDepartment, fundingAgency, fundingRegion, fundingUnit, fundingSubUnit, fundingTribe, fundingUnitType, fundingUnitTypeIgnoreNational, ignoreContributedOnly])

  useEffect(() => {
    setProjectNameSelection(filterProjectValue ? filterProjectValue : []);
    setProjectDiscoveryDateSelection(projectDiscoveryDateValue ? projectDiscoveryDateValue : []);
    setProjectIDSelection(projectIDValue ? projectIDValue : []);
    setProjectFireCodeSelection(projectFireCodeValue ? projectFireCodeValue : []);
  }, [filterProjectValue, projectDiscoveryDateValue, projectIDValue, projectFireCodeValue])

  useEffect(() => {
    if (datasetSelection===FieldNames.datasets.fuels && filter?.name===FieldNames.filters.projectFilters){
      if (filterProjectValue?.length>0){
        dispatch(setFilterProjectValue([]));
        dispatch(setProjectDiscoveryDates([]));
        dispatch(setProjectIDs([]));
        dispatch(setProjectFireCodes([]));
      }
    }
  }, [datasetSelection, filter])

  //TODO: Rework hardcodes
  const handleClick = () => {
    setOpen(!open);
  };

  const clearFilter = (eaFilter) => {
    switch(eaFilter.name) {
      case FieldNames.filters.projectFilters:
        dispatch(setFilterProjectValue([]));
        dispatch(setProjectDiscoveryDates([]));
        dispatch(setProjectIDs([]));
        dispatch(setProjectFireCodes([]));
        break;
      case FieldNames.filters.category:
        dispatch(setPostFireCategories([]));
        dispatch(setFuelsCategories([]))
        break;
      case FieldNames.filters.congressionalDistrict:
        dispatch(setCongressionalDistrict([]));
        break;
      case FieldNames.filters.type:
        dispatch(setPostFireType([]));
        dispatch(setFuelsType([]))
        break;
      case FieldNames.filters.wbsID:
        dispatch(setWbsIds([]));
        break;
      case FieldNames.filters.location:
        dispatch(setFilterGeometry(null));
        break;
      case FieldNames.filters.isRTRL:
        dispatch(setIsRTRL([]));
        break;
      case FieldNames.filters.isContract:
        dispatch(setIsContract([]));
        break;
      case FieldNames.filters.isAgreement:
        dispatch(setIsAgreement([]));
        break;
      case FieldNames.filters.fundingSource:
        dispatch(setFundingSources([]));
        break;
      case FieldNames.filters.stateCounty:
        dispatch(setState([]));
        dispatch(setCounty([]));
        break;
      case FieldNames.filters.area:
        dispatch(setMinCalculatedArea(null));
        dispatch(setMaxCalculatedArea(null));
        dispatch(setCalculatedAreaType(null));
        break;
      case FieldNames.filters.durability:
        dispatch(setMinDurability(null));
        dispatch(setMaxDurability(null));
        break;
      case FieldNames.filters.priority:
        dispatch(setPriorities([]));
        break;
      case FieldNames.filters.status:
        dispatch(setStatus([]));
        break;
      case FieldNames.filters.isCarryover:
        dispatch(setIsCarryover([]));
        break;
      case FieldNames.filters.approvals:
        dispatch(setIsDepartmentApproved(null));
        dispatch(setIsRegionApproved(null));
        dispatch(setIsAgencyApproved(null));
        dispatch(setIsLocalApproved(null));
        dispatch(setIsAllApproved(false));
        dispatch(setIsNoneApproved(false));
        break;
      case FieldNames.filters.initiationDateFiscalYear:
        dispatch(setMinInitiationDate(null));
        dispatch(setMaxInitiationDate(null));
        dispatch(setMinFiscalYear(null));
        dispatch(setMaxFiscalYear(null));
        dispatch(setInitiationFiscalQuarters([]))
        break;
      case FieldNames.filters.completionDateFiscalYear:
        dispatch(setMinCompletionDate(null));
        dispatch(setMaxCompletionDate(null));
        dispatch(setMinCompletionFiscalYear(null));
        dispatch(setMaxCompletionFiscalYear(null));
        dispatch(setCompletionFiscalQuarters([]));
        break;
      case FieldNames.filters.obligationFiscalYear:
          dispatch(setMinObligationFiscalYear(null));
          dispatch(setMaxObligationFiscalYear(null));
          break;
      case FieldNames.filters.costs:
        dispatch(setEstAssetCost([null, null]));
        dispatch(setEstContractualCost([null, null]));
        dispatch(setEstGrantsFixedCost([null, null]));
        dispatch(setEstOtherCost([null, null]));
        dispatch(setEstPersonnelCost([null, null]));
        dispatch(setEstTotalCost([null, null]));
        break;
      case FieldNames.filters.fundingOrganizations:
        dispatch(setFundingDepartment([]));
        setFundingDepartmentSelection([]);
        dispatch(setFundingUnit([]));
        dispatch(setFundingSubUnit([]));
        dispatch(setFundingTribe([]));
        setFundingUnitSelection([]);
        dispatch(setFundingRegion([]));
        setFundingRegionSelection([]);
        dispatch(setFundingAgency([]));
        setFundingAgencySelection([]);
        setFundingSubUnitSelection([]);
        setFundingTribeSelection([]);
        setFundingUnitTypeSelection([]);
        dispatch(setFundingUnitType([]));
        dispatch(setFundingUnitTypeIgnoreNational(false));
        setFundingUnitTypeIgnoreNationalVal(false);
        dispatch(setIgnoreContributedOnly(false));
        setIgnoreContributedOnlyVal(false);
        break;
      case FieldNames.filters.names:
          dispatch(setNames([]));
          break;
      case FieldNames.filters.interagencySupport:
        dispatch(setIsInteragency(null));
        break;
      default:
        break;
    }
  }

  const costFilters = (eaItem, i) => {
    if(eaItem.code === FieldNames.costFilterCodes.personnelCost){
      return (
        <MinMaxFilter key={i} min={minEstPersonnelCost} max={maxEstPersonnelCost} setMin={setMinEstPersonnelCost} setMax={setMaxEstPersonnelCost} />
      )
    } else if(eaItem.code === FieldNames.costFilterCodes.grants){
      return (
        <MinMaxFilter key={i} min={minEstGrantsFixedCost} max={maxEstGrantsFixedCost} setMin={setMinEstGrantsFixedCost} setMax={setMaxEstGrantsFixedCost} />
      )
    } else if(eaItem.code === FieldNames.costFilterCodes.asset){
      return (
        <MinMaxFilter key={i} min={minEstAssetCost} max={maxEstAssetCost} setMin={setMinEstAssetCost} setMax={setMaxEstAssetCost} />
      )
    } else if(eaItem.code === FieldNames.costFilterCodes.contractual){
      return (
        <MinMaxFilter key={i} min={minEstContractualCost} max={maxEstContractualCost} setMin={setMinEstContractualCost} setMax={setMaxEstContractualCost} />
      )
    } else if(eaItem.code === FieldNames.costFilterCodes.other){
      return (
        <MinMaxFilter key={i} min={minEstOtherCost} max={maxEstOtherCost} setMin={setMinEstOtherCost} setMax={setMaxEstOtherCost} />
      )
    } else if(eaItem.code === FieldNames.costFilterCodes.total){
      return (
        <MinMaxFilter key={i} min={minEstTotalCost} max={maxEstTotalCost} setMin={setMinEstTotalCost} setMax={setMaxEstTotalCost} />
      )
    }
  }

  const checkboxChanged = (e, checkboxType) => {
    if(e.target.checked){
      if(checkboxType === "AllApproved"){
        dispatch(setIsAllApproved(true));
        dispatch(setIsNoneApproved(false));
        dispatch(setIsDepartmentApproved('Yes'));
        dispatch(setIsAgencyApproved('Yes'));
        dispatch(setIsRegionApproved('Yes'));
        dispatch(setIsLocalApproved('Yes'));
      } else if(checkboxType === "NoneApproved"){
        dispatch(setIsAllApproved(false));
        dispatch(setIsNoneApproved(true));
        dispatch(setIsDepartmentApproved('No'));
        dispatch(setIsAgencyApproved('No'));
        dispatch(setIsRegionApproved('No'));
        dispatch(setIsLocalApproved('No'));
      }
    } else {
      if(checkboxType === "AllApproved"){
        dispatch(setIsAllApproved(false));
        dispatch(setIsDepartmentApproved(null));
        dispatch(setIsAgencyApproved(null));
        dispatch(setIsRegionApproved(null));
        dispatch(setIsLocalApproved(null));
      } else if(checkboxType === "NoneApproved"){
        dispatch(setIsNoneApproved(false));
        dispatch(setIsDepartmentApproved(null));
        dispatch(setIsAgencyApproved(null));
        dispatch(setIsRegionApproved(null));
        dispatch(setIsLocalApproved(null));
      }
    }
    
  }

  const dropdownChanged = (changedVal) => {
    if(isNoneApproved && (changedVal === FieldNames.yesNo.yes || (isDepartmentApproved === FieldNames.yesNo.yes || isRegionApproved === FieldNames.yesNo.yes || isAgencyApproved === FieldNames.yesNo.yes || isLocalApproved === FieldNames.yesNo.yes))){
      dispatch(setIsNoneApproved(false));
      
    } else if(isAllApproved && (changedVal === FieldNames.yesNo.no || (isDepartmentApproved === FieldNames.yesNo.no || isRegionApproved === FieldNames.yesNo.no || isAgencyApproved === FieldNames.yesNo.no || isLocalApproved === FieldNames.yesNo.no))){
      dispatch(setIsAllApproved(false));
    }
  }

  const setFilterType = (filterItem) => {
    if(filterItem.name === FieldNames.filters.projectFilters){
      if(datasetSelection===FieldNames.datasets.fuels){
        return <></>
      } else {
        return (
          <AutoCompleteProjectLinkedFilter
            cachedProjects={cachedProjects} setCachedProjects={setCachedProjects}
            projectNameSelection={projectNameSelection} setProjectNameSelection={setProjectNameSelection}
            projectDiscoveryDateSelection={projectDiscoveryDateSelection} setProjectDiscoveryDateSelection={setProjectDiscoveryDateSelection}
            projectIDSelection={projectIDSelection} setProjectIDSelection={setProjectIDSelection}
            projectFireCodeSelection={projectFireCodeSelection} setProjectFireCodeSelection={setProjectFireCodeSelection}
          />
        )
      }
    } else if(filterItem.name === FieldNames.filters.durability){
      return (
        <MinMaxFilter min={minDurabilityValue} max={maxDurabilityValue} setMin={setMinDurability} setMax={setMaxDurability} />
      )
    } else if(filterItem.name === FieldNames.filters.priority){
      return (
        <CheckboxFilter filter={filterItem} setValue={setPriorities} value={prioritiesValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.status) {
      return(
        <CheckboxFilter filter={filterItem} setValue={setStatus} value={statusValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.location)
    {
      return (
        <LocationFilter 
          isCreatingActualActivity={isCreatingActualActivity} 
          isCreatingActualTreatment={isCreatingActualTreatment} 
          isCreatingPlannedTreatment={isCreatingPlannedTreatment} 
          isCreatingPlannedActivity={isCreatingPlannedActivity} 
        />
      )
    } else if (filterItem.name === FieldNames.filters.area){
      return (
        <>
          <CalculatedAreaFilter filter={filterItem} min={minCalculatedAreaValue} max={maxCalculatedAreaValue} setMin={setMinCalculatedArea} setMax={setMaxCalculatedArea} type={calculatedAreaType} setType={setCalculatedAreaType} />
        </>
      )
    } else if(filterItem.name === FieldNames.filters.category){
      if(datasetSelection === FieldNames.datasets.both){
        return (
          <>
            <Grid item size={12} container direction="row" className="grid-item">
              <Grid item size={6}>
                <h4 style={{fontWeight: 400, padding: '0 0 0 15px', margin: '10px 0'}}>Fuels</h4>
              </Grid>
              <Grid item size={6}>
                <h4 style={{fontWeight: 400, padding: '0 0 0 15px', margin: '10px 0'}}>PostFire</h4>
              </Grid>
            </Grid>
            <hr width="95%" size="1" color={ ColorConstants.GrayAlien } />
            <Grid item size={12} container direction="row" className="grid-item">
              <Grid item size={6}>
                <CheckboxFilter filter={filterItem} setValue={setFuelsCategories} value={fuelsCategoryValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={false} />
              </Grid>
              <Grid item size={6}>
                <CheckboxFilter filter={filterItem} setValue={setPostFireCategories} value={postFireCategoryValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={true} />
              </Grid>
            </Grid>
          </>
        )
      } else if(datasetSelection === FieldNames.datasets.fuels){
        return (
          <CheckboxFilter filter={filterItem} setValue={setFuelsCategories} value={fuelsCategoryValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={datasetSelection === FieldNames.datasets.postfire} />
        )
      } else if(datasetSelection === FieldNames.datasets.postfire){
        return (
          <CheckboxFilter filter={filterItem} setValue={setPostFireCategories} value={postFireCategoryValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={datasetSelection === FieldNames.datasets.postfire} />
        )
      }
    } else if(filterItem.name === FieldNames.filters.type){
      if(datasetSelection === FieldNames.datasets.both){
        return (
          <>
            <Grid item size={12} container direction="row" className="grid-item">
              <Grid item size={6}>
                <h4 style={{fontWeight: 400, padding: '0 0 0 15px', margin: '10px 0'}}>Fuels</h4>
              </Grid>
              <Grid item size={6}>
                <h4 style={{fontWeight: 400, padding: '0 0 0 15px', margin: '10px 0'}}>PostFire</h4>
              </Grid>
            </Grid>
            <hr width="95%" size="1" color={ ColorConstants.GrayAlien } />
            <Grid item size={12} container direction="row" className="grid-item">
              <Grid item size={6}>
                <CheckboxFilter filter={filterItem} setValue={setFuelsType} value={fuelsTypeValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={false} />
              </Grid>
              <Grid item size={6}>
                <CheckboxFilter filter={filterItem} setValue={setPostFireType} value={postFireTypeValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={true} />
              </Grid>
            </Grid>
          </>
        )
      } else if(datasetSelection === FieldNames.datasets.fuels){
        return (
          <CheckboxFilter filter={filterItem} setValue={setFuelsType} value={fuelsTypeValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={datasetSelection === FieldNames.datasets.postfire} />
        )
      } else if(datasetSelection === FieldNames.datasets.postfire){
        return (
          <CheckboxFilter filter={filterItem} setValue={setPostFireType} value={postFireTypeValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} isPostFire={datasetSelection === FieldNames.datasets.postfire} />
        )
      }
    } else if(filterItem.name === FieldNames.filters.isRTRL){
      return (
        <CheckboxFilter filter={filterItem} setValue={setIsRTRL} value={isRTRLValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.isContract){
      return (
        <CheckboxFilter filter={filterItem} setValue={setIsContract} value={isContractValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.isAgreement){
      return (
        <CheckboxFilter filter={filterItem} setValue={setIsAgreement} value={isAgreementValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.isCarryover){
      return (
        <CheckboxFilter filter={filterItem} setValue={setIsCarryover} value={isCarryoverValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.wbsID) {
      //wbsIDValues
      return (
        <AutoCompleteFilter filter={filterItem} setValue={setWbsIds} value={wbsIDSelectedValues} codedValues={wbsIDValues} id="wbsidFilter" />
      )
    } else if(filterItem.name === FieldNames.filters.fundingSource){
      return (
        <CheckboxFilter filter={filterItem} setValue={setFundingSources} value={fundingSourceValue} postFireCategories={postFireCategoryValue} fuelsCategories={fuelsCategoryValue} />
      )
    } else if(filterItem.name === FieldNames.filters.fundingOrganizations){
      return(
        <AutoCompleteLinkedFilter
          fundingDepartmentSelection={fundingDepartmentSelection} setFundingDepartmentSelection={setFundingDepartmentSelection}
          fundingAgencySelection={fundingAgencySelection} setFundingAgencySelection={setFundingAgencySelection}
          fundingRegionSelection={fundingRegionSelection} setFundingRegionSelection={setFundingRegionSelection}
          fundingUnitSelection={fundingUnitSelection} setFundingUnitSelection={setFundingUnitSelection}
          fundingSubUnitSelection={fundingSubUnitSelection} setFundingSubUnitSelection={setFundingSubUnitSelection}
          fundingUnitTypeSelection={fundingUnitTypeSelection} setFundingUnitTypeSelection={setFundingUnitTypeSelection}
          fundingUnitTypeIgnoreNationalVal={fundingUnitTypeIgnoreNationalVal} setFundingUnitTypeIgnoreNationalVal={setFundingUnitTypeIgnoreNationalVal}
          fundingTribeSelection={fundingTribeSelection} setFundingTribeSelection={setFundingTribeSelection}
          ignoreContributedOnlyVal={ignoreContributedOnlyVal} setIgnoreContributedOnlyVal={setIgnoreContributedOnlyVal}
          />
      )

    } else if(filterItem.name === FieldNames.filters.congressionalDistrict){
      return (
        <AutoCompleteFilter filter={filterItem} setValue={setCongressionalDistrict} value={congressDistValue} codedValues={congressDistValues} id="congDistFilter" />
      )
    } else if(filterItem.name === FieldNames.filters.stateCounty)
    {
      return (
        <StateCountyFilter setStateValue={setState} stateValue={stateValue} setCountyValue={setCounty} countyValue={countyValue} />
      )
    } else if(filterItem.name === FieldNames.filters.approvals) {
      return(
        <Fragment>
          <FormControlLabel style={{ margin: '10px 0 2px 15px' }}
            control={
              <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: ColorConstants.BlueAlien }} id="AllApproved" checked={isAllApproved ? true : false} onClick={(e) => checkboxChanged(e, "AllApproved")} />
            } label="All Approved"
          />
          <FormControlLabel style={{ margin: '10px 0 2px 15px' }}
            control={
              <Checkbox style={{ padding: '0', margin: '0 5px 0 0px', borderColor: ColorConstants.BlueAlien }} id="NoneApproved" checked={isNoneApproved ? true : false} onClick={(e) => checkboxChanged(e, "NoneApproved")} />
            } label="None Approved"
          />
          <div style={{ display: 'flex', flexDirection: 'column'}} >
            <div style={{ display: 'flex', flexDirection: 'row' }} >
              <DropdownFilter filter={filterItem} setValue={setIsDepartmentApproved} value={isDepartmentApproved} name="Department Approved" wide={true} dropdownChanged={dropdownChanged} />
              <DropdownFilter filter={filterItem} setValue={setIsAgencyApproved} value={isAgencyApproved} name="Agency Approved" wide={true} dropdownChanged={dropdownChanged} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row'}} >
              <DropdownFilter filter={filterItem} setValue={setIsRegionApproved} value={isRegionApproved} name="Region Approved" wide={true} dropdownChanged={dropdownChanged} />
              <DropdownFilter filter={filterItem} setValue={setIsLocalApproved} value={isLocalApproved} name="Local Approved" wide={true} dropdownChanged={dropdownChanged} />
            </div>
          </div>
        </Fragment>
      )

    } else if(filterItem.name === FieldNames.filters.interagencySupport) {
      return(
        <Fragment>
          
          <div style={{ display: 'flex', flexDirection: 'column'}} >
            <div style={{ display: 'flex', flexDirection: 'row' }} >
              <DropdownFilter filter={filterItem} setValue={setIsInteragency} value={isInteragency} name="Is Interagency Support" wide={true} dropdownChanged={dropdownChanged} />
            </div>
          </div>
        </Fragment>
      )

    } else if(filterItem.name === FieldNames.filters.initiationDateFiscalYear){
      return (
        <Fragment>
          <ToFromDateFilter setMinDate={setMinInitiationDate} minDate={minInitiationDateValue} setMaxDate={setMaxInitiationDate} maxDate={maxInitiationDateValue} />
          <FiscalYearFilter minFiscalYear={minFiscalYear} maxFiscalYear={maxFiscalYear} setMinFiscalYear={setMinFiscalYear} setMaxFiscalYear={setMaxFiscalYear} />
          <FiscalQuarterFilter filter={filterItem} selectionItem={initiationFiscalQuarterSelection} setValue={setInitiationFiscalQuarters} value={initiationFiscalQuartersValue}  />
        </Fragment>
      )
    } else if(filterItem.name === FieldNames.filters.completionDateFiscalYear){
      return (
        <Fragment>
          <ToFromDateFilter setMinDate={setMinCompletionDate} minDate={minCompletionDateValue} setMaxDate={setMaxCompletionDate} maxDate={maxCompletionDateValue} />
          <FiscalYearFilter minFiscalYear={minCompletionFiscalYear} maxFiscalYear={maxCompletionFiscalYear} setMinFiscalYear={setMinCompletionFiscalYear} setMaxFiscalYear={setMaxCompletionFiscalYear} />
          <FiscalQuarterFilter filter={filterItem} selectionItem={completionFiscalQuarterSelection} setValue={setCompletionFiscalQuarters} value={completionFiscalQuartersValue}  />
        </Fragment>
      )
    } else if(filterItem.name === FieldNames.filters.obligationFiscalYear){
      return (
        <Fragment>
          <FiscalYearFilter minFiscalYear={minObligationFiscalYear} maxFiscalYear={maxObligationFiscalYear} setMinFiscalYear={setMinObligationFiscalYear} setMaxFiscalYear={setMaxObligationFiscalYear} />
        </Fragment>
      )
    } else if(filterItem.name === FieldNames.filters.costs){
      return (
        <Fragment>
          {filterItem.domain?.codedValues.map((eaItem, i) => (
            <div key={i}>
              <InputLabel style={{color: ColorConstants.GrayAlien, padding: '10px 0 0 10px'}}>{eaItem.name}</InputLabel>
              {costFilters(eaItem, i)}
            </div>
          ))}
        </Fragment>
      )
    } else if(filterItem.name === FieldNames.filters.names) {
      //nameValues
      return (
        <AutoCompleteFilter filter={filterItem} setValue={setNames} value={nameValues} codedValues={null} id="nameFilter" 
          rootServiceUrl={rootServiceUrl} config={config} cachedValues={cachedNameValues} setCachedValues={setCachedNameValues}
        />
      )
    } else {
      return (
        <TextFilter filter={filterItem} />
      )
    }
  }

  const icons = (filterName) => {
      let hide = true;
      //Check for each section if we should hide or show the trash can
      switch(filterName) {
        case FieldNames.filters.projectFilters:
          if((filterProjectValue && filterProjectValue.length !== 0) ||
          (projectDiscoveryDateValue && projectDiscoveryDateValue.length !== 0) ||
          (projectIDValue && projectIDValue.length !== 0) ||
          (projectFireCodeValue && projectFireCodeValue.length !== 0)){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.category:
          if(postFireCategoryValue?.length !== 0 || fuelsCategoryValue?.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.priority:
          if(prioritiesValue && prioritiesValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.status:
          if(statusValue && statusValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.location:
          if(filterGeometryValue !== null) {
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.congressionalDistrict:
          if(congressDistValue && congressDistValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.type:
          if(postFireTypeValue?.length !== 0 || fuelsTypeValue?.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.isRTRL:
          if(isRTRLValue && isRTRLValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.isContract:
          if(isContractValue && isContractValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.isAgreement:
          if(isAgreementValue && isAgreementValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.isCarryover:
          if(isCarryoverValue && isCarryoverValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.wbsID:
          if(wbsIDSelectedValues && wbsIDSelectedValues.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.fundingSource:
          if(fundingSourceValue && fundingSourceValue.length !== 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.stateCounty:
          if((stateValue && stateValue.length !== 0) || (countyValue && countyValue.length !== 0)){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.area:
          if((!minCalculatedAreaValue) && (!maxCalculatedAreaValue) && !calculatedAreaType){
            hide = true;
          } else {
            hide = false;
          }
          break;
        case FieldNames.filters.durability:
          if((!minDurabilityValue) && (!maxDurabilityValue)){
            hide = true;
          } else {
            hide = false;
          }
          break;
        case FieldNames.filters.approvals:
          if(isDepartmentApproved !== null || isRegionApproved !== null || isAgencyApproved !== null || isLocalApproved !== null || isAllApproved || isNoneApproved){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.interagencySupport:
          if(!isInteragency){
            hide = true;
          } else {
            hide = false;
          }
          break;
        case FieldNames.filters.initiationDateFiscalYear:
          if(minInitiationDateValue|| maxInitiationDateValue || minFiscalYear || maxFiscalYear || (initiationFiscalQuartersValue && initiationFiscalQuartersValue.length > 0)){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.completionDateFiscalYear:
          if(minCompletionDateValue|| maxCompletionDateValue || minCompletionFiscalYear || maxCompletionFiscalYear || (initiationFiscalQuartersValue && completionFiscalQuartersValue.length > 0)){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.obligationFiscalYear:
          if(minObligationFiscalYear || maxObligationFiscalYear){
            hide = false;
          } else {
            hide = true;
          }
            break;
        case FieldNames.filters.names:
          if(nameValues?.length > 0){
            hide = false;
          } else {
            hide = true;
          }
          break;
        case FieldNames.filters.costs:
          if(minEstPersonnelCost || maxEstPersonnelCost || 
            minEstGrantsFixedCost || maxEstGrantsFixedCost ||
            minEstAssetCost || maxEstAssetCost ||
            minEstContractualCost || maxEstContractualCost ||
            minEstOtherCost || maxEstOtherCost||
            minEstTotalCost|| maxEstTotalCost){
            hide = false;
          } else {
            hide = true;
          }
          break;
          case FieldNames.filters.fundingOrganizations:
            if((fundingDepartment && fundingDepartment.length !== 0) || (fundingAgency && fundingAgency.length !== 0) ||
              (fundingRegion && fundingRegion.length !== 0) || (fundingUnit && fundingUnit.length !== 0) || 
              (fundingSubUnit && fundingSubUnit.length !== 0) || (fundingUnitType && fundingUnitType.length !== 0) ||
              (fundingUnitTypeIgnoreNationalVal !== null && fundingUnitTypeIgnoreNationalVal === true) ||
              (ignoreContributedOnlyVal !== null && ignoreContributedOnlyVal === true) ||
              (fundingTribe && fundingTribe.length !== 0)){
              hide = false;
            } else {
              hide = true;
            }
            break;
        default:
          break;
      }

      let arrow;
      if(open){
        arrow = (<ExpandLess />);
      } else {
        arrow = (<ExpandMore />);
      }

      let trashIcon = (<span></span>);
      
      if(!hide){
        trashIcon = (
          <DeleteIcon
            className="filter-item-header-clear"
            color={ColorConstants.GrayAlien}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              clearFilter(filter);
              
            }}
            style={{width: "20px", height: "20px"}} />
        )
      }

      return (
      <div className="filter-item-header-icon-container">
        {trashIcon}
        {arrow}
      </div>
      )
  }

  const typeValuesArray = (isFilterPostFire) => {
    let typeValues = [];
    let postFireTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.postFire]?.[FieldNames.categoryAssociationFields.types];
    let fuelsTypeValues = actionCategoryAssociations?.[FieldNames.categoryAssociationFields.fuels]?.[FieldNames.categoryAssociationFields.types];
    //Fuels accounting for categories
    let fuelsItemsForFiltering = [];
    fuelsCategoryValue?.forEach((eaCategory) => {
      fuelsItemsForFiltering.push(actionCategoryAssociations?.[FieldNames.categoryAssociationFields.categories]?.[eaCategory]?.[FieldNames.categoryAssociationFields.types])
    })

    if(fuelsItemsForFiltering?.length){
      //Flatten the array so it's just 1 array and remove duplicates
      fuelsItemsForFiltering = [...new Set(fuelsItemsForFiltering.flat())]
    }

    if(fuelsItemsForFiltering?.length){
      //Only include the types that exist for the selected category
      fuelsTypeValues = fuelsTypeValues.filter(x => fuelsItemsForFiltering?.includes(x))
    }

    //Post Fire accounting for categories
    let postFireItemsForFiltering = [];
    postFireCategoryValue?.forEach((eaCategory) => {
      postFireItemsForFiltering.push(actionCategoryAssociations?.[FieldNames.categoryAssociationFields.categories]?.[eaCategory]?.[FieldNames.categoryAssociationFields.types])
    })

    if(postFireItemsForFiltering?.length){
      //Flatten the array so it's just 1 array and remove duplicates
      postFireItemsForFiltering = [...new Set(postFireItemsForFiltering.flat())]
    }

    if(postFireItemsForFiltering?.length){
      //Only include the types that exist for the selected category
      postFireTypeValues = postFireTypeValues.filter(x => postFireItemsForFiltering?.includes(x))
    }

    //What is returned depends on if it is Post Fire, Fuels, or Both
    if(datasetSelection===FieldNames.datasets.fuels){
      typeValues = fuelsTypeValues
    } else if(datasetSelection===FieldNames.datasets.postfire){
      typeValues = postFireTypeValues
    } else if(datasetSelection===FieldNames.datasets.both){
      if(isFilterPostFire){
        typeValues = postFireTypeValues
      } else {
        typeValues = fuelsTypeValues
      }
    } 
    return typeValues;
  }

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    if (isCheckAll) {
      dispatch(setFuelsType([]));
      dispatch(setPostFireType([]))
    } else {
      dispatch(setFuelsType(typeValuesArray(false)));
      dispatch(setPostFireType(typeValuesArray(true)));
    }
  }

  const selectAllFilter = (filterItem) => {
    if(filterItem.name === FieldNames.filters.type){
      // if length of typeValue is equal to typeValuesArray then select all is checked
      if(fuelsTypeValue?.length !== typeValuesArray(false).length || postFireTypeValue?.length !== typeValuesArray(true).length){
        isCheckAll === true && setIsCheckAll(false)
      } else {
        isCheckAll === false && setIsCheckAll(true);
      }
              
      return(
        <div style={{ marginTop: 10 }}>
          <Checkbox
                        type="checkbox"
                        name="selectAll"
                        id="selectAll"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleSelectAll(filter);
                        }}
                        checked={isCheckAll}
                      />
          <label>Select All</label>
          <hr width="95%" size="1" color={ ColorConstants.BlueAlien } />
        </div>
      )
    }
  }

  if (datasetSelection===FieldNames.datasets.fuels && filter?.name===FieldNames.filters.projectFilters){
    return <Fragment/>;
  } else{
    return (
      <Fragment>
        <ThemeProvider theme={theme}>
            <ListItem style={{zIndex: 1}}
              className={open ? classes.filterItemHeaderSelected : classes.filterItemHeader}
              onClick={handleClick}
            >
              <ListItemText primary={filter ? filter.name : ""} />
              {icons(filter?.name)}
            </ListItem>
        </ThemeProvider>
        <Collapse in={open} timeout="auto" unmountOnExit style={{backgroundColor: ColorConstants.LightGrayAlien, borderBottom: '1px solid', borderBottomColor: ColorConstants.BlueAlien}}>
          <List component="div"
            style={{padding: '0px', backgroundColor: ColorConstants.LightGrayAlien}}
          >
            {selectAllFilter(filter)}
            <div>
              {setFilterType(filter)}
            </div>
          </List>
        </Collapse>
      </Fragment>
    );
  }
}